import React, { useCallback, useEffect, useState } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import styled from "styled-components/macro";

import { createSearchParams, Navigate, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../store";
import userSlice from "../../../reducer/user";
import Modal from "../../../components/Modal";
import { InfoType, settingUsertype } from "../../../reducer/userpayloadtypes";
import axios from "axios";

const Container = styled.div`
  background-color: #fff;
  min-height: 100vh;
`;

const PageTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  padding: 15px 40px;
  width: 100%;
  .move-btn {
    width: 30px;
    & img {
      width: 100%;
    }
  }
  .pagetit {
    font-size: 1.13em;
    font-family: "spoqa500";
    margin-left: 10px;
  }

  @media screen and (min-width: 1050px) {
    font-size: 1.4em;
    p {
      & img {
        width: 30%;
      }
    }
  }
`;

const FirstCon = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 10px 20px;
  background-color: #f7f7f7;

  padding: 10px;
`;

const FlexCon = styled.div`
  background-color: #f7f7f7;
  height: 61px;
  display: flex;
  align-items: center;
  padding: 0px 20px;

  justify-content: space-between;
  div {
    display: flex;
    font-size: 16px;
    align-items: center;
  }

  .profilecon {
    background-color: #73972c;
    border: 0.5px solid #73972c;
    width: 80px;
    height: 35px;
    color: white;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    cursor: pointer;
  }
`;

const AddList = styled.div`
  background-color: #fff;
  height: 61px;
  display: flex;
  align-items: center;
  padding: 0px 20px;
  margin: 10px 0px;
  border-radius: 10px;
  justify-content: space-between;
  div {
    display: flex;
    font-size: 16px;
    align-items: center;
  }

  .profilecon {
    background-color: #73972c;
    border: 0.5px solid #73972c;
    width: 80px;
    height: 35px;
    color: white;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
    border-radius: 5px;

    cursor: pointer;
  }

  .delete {
    background-color: #fff;
    border: 0.5px solid #656565;
    width: 80px;
    height: 35px;
    color: #656565;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 5px;
    border-radius: 5px;
    cursor: pointer;
  }

  .addressid {
    font-size: 14px;
    color: #2a3a4b;
    margin-right: 10px;
    font-weight: bold;
  }

  .addressname {
    font-size: 14px;
    color: #656565;
    font-weight: 600;
  }
`;

const ModalWrapper = styled.div`
  background-color: white;
  border-radius: 10px;
  width: 450px;
  height: 500px;
  display: flex;

  flex-direction: column;
  padding: 20px 20px 0px 20px;
  div:last-child {
    display: flex;
  }
  p {
    background-color: #72b7fb;
    border-radius: 10px;
    width: 100px;
    text-align: center;
    margin: 0px 10px;
    padding: 10px 0px;
    color: white;
  }
`;

const ModalBack = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
`;

const GoBackCon = styled.div`
  height: 30px;
  display: flex;
  justify-content: flex-end;
  img {
    width: 20px;
    cursor: pointer;
  }
`;

const Title = styled.div`
  color: #000000;
  font-weight: 16px;
  font-weight: bold;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  div {
    color: #656565;
    margin-bottom: 10px;
  }
`;

const Input = styled.input`
  border: 1px solid #dddddd;
  height: 40px;
  background-color: #f5f5f5;
  border-radius: 5px;
`;

const SaveCon = styled.div`
  width: 100%;
  margin-top: 30px;
  div {
    width: 90%;
    background-color: oldlace;
    margin: 0 auto;
    background-color: #73972c;
    height: 44px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }
`;

const AddressList = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [createmodal, setCreatemodal] = useState<boolean>(false);
  const [savemodal, setSavemodal] = useState<boolean>(false);

  const [deletemodal, setDeletemodal] = useState<boolean>(false);

  const [createUser, setCreateUser] = useState<InfoType>({
    name: "",
    id: "",
    password: "",
    confirmpassword: "",
  });

  const [userList, setUserList] = useState<settingUsertype[]>([]);

  const [deletmemberId, setDeletmemberId] = useState<any>(0);

  const [deleteUserid, setdeleteUserid] = useState<any>(0);

  useEffect(() => {
    dispatch(userSlice.actions.Routerpath("/AddressList"));
  }, []);

  const hello = new Array(2).fill("");

  const modalfunc = useCallback(
    (type: string, memberId?: number, userId?: string) => {
      if (type === "deletemodal") {
        setDeletemodal(true);
        setDeletmemberId(memberId);
        setdeleteUserid(userId);
      } else if (type === "createmodal") {
        setCreatemodal(true);
      } else if (type === "savemodal") {
        setSavemodal(true);
      }
    },
    []
  );

  const deletepostfunc = useCallback(
    async (type: string) => {
      if (type === "YES") {
        let datas: any = {
          memberId: deletmemberId,
          userId: deleteUserid,
        };

        const response = await axios.delete(`/ifactory/api/member/delete`, {
          data: datas,
        });

        getUsersList();
        setDeletemodal(false);
      } else if (type === "NO") {
        setDeletemodal(false);
      }
    },
    [deletemodal, deletmemberId, deleteUserid]
  );

  const savepostfunc = useCallback(
    async (type: string) => {
      if (type === "YES") {
        if (
          createUser.id.includes(" ") ||
          createUser.password.includes(" ") ||
          createUser.confirmpassword.includes(" ") ||
          createUser.name.includes(" ")
        ) {
          return confirmAlert({
            title: "텍스트에 공백이 있습니다. 공백을 제거해주세요",
            buttons: [
              {
                label: "Yes",
              },
            ],
          });
        }

        if (createUser.password !== createUser.confirmpassword) {
          return confirmAlert({
            title: "비밀번호가 일치하지 않습니다.",
            buttons: [
              {
                label: "Yes",
              },
            ],
          });
        }

        if (!createUser.id) {
          return confirmAlert({
            title: "아이디를 입력해주세요.",
            buttons: [
              {
                label: "Yes",
              },
            ],
          });
        }

        if (!createUser.name) {
          return confirmAlert({
            title: "이름을 입력해주세요.",
            buttons: [
              {
                label: "Yes",
              },
            ],
          });
        }

        if (!createUser.password) {
          return confirmAlert({
            title: "비밀번호를 입력해주세요.",
            buttons: [
              {
                label: "Yes",
              },
            ],
          });
        }

        // navigate(-1);
        setCreatemodal(false);
        setSavemodal(false);

        let data = {
          roleCode: "FARMER",
          userId: createUser.id,
          mobilePhoneNumber: "",
          name: createUser.name,
          email: "",
          password: createUser.password,
        };

        const response = await axios.post(`/ifactory/api/submember`, data);

        setSavemodal(false);
        getUsersList();
      } else if (type === "NO") {
        // setDeletemodal(false);
        setSavemodal(false);
      }
      setCreateUser({
        name: "",
        id: "",
        password: "",
        confirmpassword: "",
      });
    },
    [deletemodal, createUser]
  );

  const onChangefunc = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setCreateUser({ ...createUser, [e.target.name]: e.target.value });
    },
    [createUser]
  );

  const getUsersList = async () => {
    const response = await axios.get(`/ifactory/api/member/findsubmemberlist`);

    setUserList(response.data);
  };

  useEffect(() => {
    getUsersList();
  }, []);

  const gotonavifunc = useCallback((type: string, user: settingUsertype) => {
    if (type === "CreateAddress") {
      navigate("/CreateAddress");
    } else if ("ProfileAdjust") {
      navigate({
        pathname: "/ProfileAdjust",
        search: createSearchParams({
          userId: user?.userId,
          name: user?.name,
          memberId: user?.memberId.toString(),
        }).toString(),
      });
    }
  }, []);

  return (
    <Container>
      <PageTop>
        <p className="move-btn">
          <img
            src="./img/ArrowLeft.svg"
            onClick={() => {
              navigate(-1);
            }}
          />
        </p>
        <p className="pagetit">개인설정</p>
      </PageTop>
      <FirstCon>
        <FlexCon>
          <div>
            <div>계정목록</div>
          </div>
          <div className="profilecon" onClick={() => modalfunc("createmodal")}>
            계정만들기
          </div>
        </FlexCon>

        {userList.map((user) => {
          return (
            <AddList>
              <div>
                <div className="addressid">{user.userId}</div>
                <div className="addressname">{user.name}</div>
              </div>
              <div className="wappers">
                <div
                  className="delete"
                  onClick={() =>
                    modalfunc("deletemodal", user.memberId, user.userId)
                  }
                >
                  삭제
                </div>
                <div
                  className="profilecon"
                  onClick={() => gotonavifunc("ProfileAdjust", user)}
                >
                  수정
                </div>
              </div>
            </AddList>
          );
        })}
      </FirstCon>
      {deletemodal && (
        <Modal
          title={"정말로 삭제하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => deletepostfunc("YES")}
          secondclick={() => deletepostfunc("NO")}
        />
      )}

      {createmodal && (
        <div>
          <ModalBack>
            <ModalWrapper>
              <GoBackCon>
                <img
                  src="./img/X.svg"
                  onClick={() => {
                    setCreatemodal(false);
                  }}
                  alt="X"
                />
              </GoBackCon>
              <Title>계정만들기</Title>
              <InputWrapper>
                <Wrapper>
                  <div>아이디</div>
                  <Input
                    type="id"
                    id="id"
                    name="id"
                    placeholder="아이디"
                    value={createUser.id}
                    onChange={onChangefunc}
                  />
                </Wrapper>
                <Wrapper>
                  <div>이름</div>
                  <Input
                    type="name"
                    id="name"
                    name="name"
                    placeholder="이름"
                    value={createUser.name}
                    onChange={onChangefunc}
                  />
                </Wrapper>
                <Wrapper>
                  <div>비밀번호</div>
                  <Input
                    type="password"
                    id="password"
                    name="password"
                    placeholder="비밀번호"
                    value={createUser.password}
                    onChange={onChangefunc}
                  />
                </Wrapper>

                <Wrapper>
                  <div>비밀번호 확인</div>
                  <Input
                    type="password"
                    id="confirmpassword"
                    name="confirmpassword"
                    placeholder="비밀번호"
                    value={createUser.confirmpassword}
                    onChange={onChangefunc}
                  />
                </Wrapper>
                <SaveCon>
                  <div onClick={() => modalfunc("savemodal")}>저장</div>
                </SaveCon>
              </InputWrapper>
            </ModalWrapper>
          </ModalBack>
        </div>
      )}

      {savemodal && (
        <Modal
          title={"정말로 계정을 생성하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => savepostfunc("YES")}
          secondclick={() => savepostfunc("NO")}
        />
      )}
    </Container>
  );
};

export default AddressList;
